import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { authManager } from '../utils/auth';

const Base_Url = process.env.REACT_APP_API_BASE_URL;

const Product_View = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);

    useLayoutEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const res = await authManager.authenticatedFetch(`${Base_Url}/shopping/products/${id}`);
                if (!res.ok) throw new Error("Fetch failed");
                const data = await res.json();
                setProduct(data.result);
            } catch (err) {
                console.error("Failed to load product:", err);
                navigate('/login');
            } finally {
                setLoading(false);
            }
        };

        fetchProduct();
    }, [id, navigate]);


    if (!loading && !product) return <div className="text-center mt-5">Product not found.</div>;

   const stars = product
        ? Array.from({ length: 5 }).map((_, index) => (
            <span key={index} className={index < (product.rating || 0) ? 'f_yellow' : 'f_grey2'}>
                <i className="fa-solid fa-star" />
            </span>
        ))
        : null;

    return (
        <div>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2 align-items-center">
                        <div className="col-6 col-sm-6">
                            <h1 className="m-0 txt_lft">Products</h1>
                        </div>
                        <div className="col-6 col-sm-6">
                            <ol className="breadcrumb justify-content-end">
                                <li className="breadcrumb-item">
                                    <Link to="/products"><i className="fa-solid fa-arrow-left-long" /> Back</Link>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="frmwdth_cntr">
                            <div className="col-lg-12">
                                <div className="card card-primary card-outline">
                                    {loading ? (
                                        <div className="card-body text-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <form className="form-horizontal">
                                            <div className="card-body">
                                                <div className="form-group row align-items-center">
                                                    <label className="col-12 col-md-4 col-form-label">Name</label>
                                                    <div className="col-12 col-md-8">
                                                        {product.title}
                                                    </div>
                                                </div>

                                                <div className="form-group row">
                                                    <label className="col-12 col-md-4 col-form-label">Image</label>
                                                    <div className="col-12 col-md-8">
                                                        <div className="d-flex flex-row flex-wrap pt-20 pb-15">
                                                            <div className="community_imgwrapper">
                                                                <div className="community_icon">
                                                                    <img src={product.productLogo} alt="Product" style={{ width: '120px', height: 'auto' }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group row align-items-center">
                                                    <label className="col-12 col-md-4 col-form-label">Affiliate Platforms</label>
                                                    <div className="col-12 col-md-8">
                                                        {product.metadata?.source || 'N/A'}
                                                    </div>
                                                </div>

                                                <div className="form-group row align-items-center">
                                                    <label className="col-12 col-md-4 col-form-label">Brand</label>
                                                    <div className="col-12 col-md-8">
                                                        {product.brandId?.name || 'N/A'}
                                                    </div>
                                                </div>

                                                <div className="form-group row">
                                                    <label className="col-12 col-md-4 col-form-label">Description</label>
                                                    <div className="col-12 col-md-8">
                                                        {product.description}
                                                    </div>
                                                </div>

                                                <div className="form-group row align-items-center">
                                                    <label className="col-12 col-md-4 col-form-label">Price</label>
                                                    <div className="col-12 col-md-3">
                                                        {'$'} {product.price?.amount || 0}
                                                    </div>
                                                </div>

                                                <div className="form-group row align-items-center">
                                                    <label className="col-12 col-md-4 col-form-label">Rating</label>
                                                    <div className="col-12 col-md-8">
                                                        <div className="tp-product-rating-icon">
                                                            {stars}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card-footer text-center">
                                                {/* <button type="button" className="btn btn-danger">Delete</button> */}
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Product_View;
